const authPl = {
    "sign_in": "Zalogować się",
    "email": "Adres e-mail",
    "password": "Hasło",
    "sign_in_button": "Zalogować się",
    "invalid_credentials": "Nieprawidłowe dane uwierzytelniające",
    "password_min_length": "Hasło musi mieć co najmniej 8 znaków",
    "passwords_do_not_match": "Hasła nie pasują",
    "invalid_token": "Nieprawidłowy token",
    "password_set": "Ustawiono hasło",
    "confirm_password": "Potwierdź hasło",
    "confirm_title": "Potwierdzenie rejestracji administratora Quickpick",
    "confirm_text": "Aby założyć konto, wystarczy podać bezpieczne hasło",
    "set_password": "Ustaw hasło",
    "account_activated": "Konto aktywowane",
    "account_activated_text": "Możesz teraz zalogować się na swoje konto użytkownika, podając swój adres e-mail i hasło",
    "continue_to_login": "Kontynuuj logowanie",
    "forgotten_password": "Zapomniane hasło",
    "unable_to_reset_password": "Błąd wewnętrzny, nie można zresetować hasła.",
    "reset_password_title": "Zresetuj hasło",
    "reset_password_text": "Podaj adres e-mail użyty do Twojego konta. Link do resetowania hasła wyślemy na ten adres.",
    "send_reset_mail": "Wyślij link do resetowania hasła",
    "send_reset_mail_success": "Na podany adres wysłano wiadomość e-mail z dalszymi instrukcjami",
    "invalid_email": "Nieprawidłowy adres e-mail",
    "reset_sent": "E-mail wysłany",
    "change_password_title": "Zmień hasło",
    "change_password_success": "Hasło zostało pomyślnie zmienione",
    "roles": {
        "OWNER": "Administrator",
        "MENU_EDITOR": "Edycja menu",
        "STAFF_MANAGER": "Zarządzanie personelem"
    },
    "name": "Nazwa",
    "permissions": "Uprawnienia",
    "create_user_permissions": "Utwórz uprawnienia użytkownika",
    "add_restaurant": "Dodaj restaurację",
    "user_saved": "Użytkownik zapisał",
    "has_admin_permissions": "Uprawnienia administratora",
    "login_with_google": "Zaloguj się za pomocą Google",
    "missing_perrmissions": "Nie masz uprawnień wymaganych do dostępu do tej strony",
    "qp_signup_title": "Rejestracja QuickPick",
    "qp_signup_text": "Wypełnij poniższe pola, aby utworzyć konto użytkownika!",
    "user_information": "Informacje o użytkowniku",
    "restaurant_information": "Informacje o restauracji",
    "restaurant_shortname": "Identyfikator restauracji",
    "restaurant_name": "Nazwa restauracji",
    "create_profile": "Tworzyć",
    "restaurant_name_short": "Nazwa restauracji musi mieć co najmniej 3 znaki",
    "identifier_example": "Przykładowy identyfikator",
    "invalid_shortname": "Identyfikator restauracji musi mieć co najmniej 3 znaki",
    "restaurant_shortname_already_in_use": "Identyfikator restauracji jest już używany",
    "name_missing": "Brak nazwy",
    "signup_failed": "Rejestracja nie powiodła się. Spróbuj ponownie później.",
    "no_restaurant_title": "Nie wybrano żadnej restauracji dla Twojego konta",
    "no_restaurant_text": "Jeżeli właśnie założyłeś konto, powinieneś także zarejestrować swoją restaurację!",
    "no_restaurant_alt": "Jeśli miałbyś otrzymać dostęp do restauracji, skontaktuj się z administratorem restauracji.",
    "no_user_created_yet": "Nie masz jeszcze konta?",
    "signup_success": "Rejestracja pomyślna",
    "grant_admin_title": "Udziel uprawnień administratora",
    "grant_admin_confirmation": "Użytkownik z uprawnieniami administratora może zarządzać ustawieniami restauracji, dodawać i usuwać użytkowników, zarządzać subskrypcjami, płatnościami i fakturami. Edycja menu nie wymaga uprawnień administratora.",
    "selected_user": "Wybrany użytkownik",
    "delete_user_title": "Usuń użytkownika",
    "delete_user_confirmation": "Wybrany użytkownik zostanie usunięty z restauracji i nie będzie miał już dostępu do jej menu. Tej czynności nie można cofnąć.",
    "admin": "Administrator",
    "activate_account": "Aktywuj konto",
    "account_pending_activation": "Twoje konto użytkownika oczekuje na aktywację.",
    "check_your_activate_email": "Sprawdź swoją skrzynkę odbiorczą i kliknij link aktywacyjny",
    "refresh_page": "Odśwież stronę",
    "did_not_receive_activation_email": "Nie otrzymałem wiadomości e-mail z linkiem aktywacyjnym",
    "activate_tip": "Jeśli nie możesz znaleźć e-maila aktywacyjnego, sprawdź również folder ze spamem. Jeśli go tam nie ma, kliknij poniższy przycisk, aby wysłać go ponownie.",
    "resend_email": "Wyślij ponownie",
    "email_resent": "E-mail z informacją o aktywacji został pomyślnie wysłany ponownie. Sprawdź swoją skrzynkę odbiorczą.",
    "accept_terms_and_conditions": "Przeczytałem i akceptuję <a>Warunki korzystania z serwisu oraz Politykę prywatności</a>",
    "complete_registration": "Zakończ rejestrację",
    "auth_in_progress": "Trwa uwierzytelnianie...",
    "account_successfully_activated": "Twoje konto QuickPick zostało pomyślnie aktywowane",
    "continue_to_home_page": "Przejdź do strony głównej",
    "invalid_activation": "Wystąpił błąd podczas aktywacji konta. Spróbuj ponownie później lub skontaktuj się z naszym działem obsługi klienta.",
    "activation_mail_sent": "Rozpoczęliśmy tworzenie Twojego konta. Sprawdź swoją skrzynkę e-mail i dokończ rejestrację, klikając link w wiadomości e-mail."
};

export default authPl;
